import * as React from 'react';
import useLabelTranslation from 'src/hooks/useLabelTranslation';

import {usePointerDrag} from 'src/hooks/usePointerDrag';
import classify from 'src/utils/classify';

import HoverIconButton from 'src/components/lib/hover-icon-button/index';

import CancelIcon from 'src/images/icons/cancel-icon.svg';

import css from './popover.css';


export default function Popover({
  onClose,
  titleText,
  titleContent,
  children,
  className,
}: {
  onClose: () => unknown;
  titleText: string;
  titleContent?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}) {
  const {t, makeKey} = useLabelTranslation();
  const positionRef = React.useRef({x: 0, y: 0});
  // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
  const rootRef = React.useRef<HTMLElement | null | undefined>();
  // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
  const headerRef = React.useRef<HTMLElement | null | undefined>();

  const [dragProps] = usePointerDrag({
    validateDownEvent: (event) => event.target === headerRef.current,
    onMove: ({deltaX, deltaY}) => {
      if (rootRef.current) {
        const position = positionRef.current;
        position.x += deltaX;
        position.y += deltaY;
        rootRef.current.style.transform = `translate(${positionRef.current.x}px, ${positionRef.current.y}px)`;
        document.body?.style.setProperty('cursor', 'grabbing');
      }
    },
    onDone: () => {
      document.body?.style.removeProperty('cursor');
    },
  });

  return (
    // @ts-expect-error - TS2322 - Type 'RefObject<HTMLElement | null | undefined>' is not assignable to type 'Ref<HTMLDivElement> | undefined'.
    <div className={classify(css.root, className)} ref={rootRef}>
      <div className={css.header} {...dragProps}>
        {/* @ts-expect-error - TS2322 - Type 'RefObject<HTMLElement | null | undefined>' is not assignable to type 'Ref<HTMLDivElement> | undefined'. */}
        <div className={css.draggable} ref={headerRef} />
        <div className={css.title}>
          <span>{t(makeKey(titleText), titleText)}</span>
          <HoverIconButton className={css.x} onClick={onClose}>
            <CancelIcon />
          </HoverIconButton>
        </div>

        {titleContent}
      </div>

      {children}
    </div>
  );
}
